import { useTranslation } from 'react-i18n-lite'

import { formatFileSize } from 'modules/shared/utils/formatFileSize'
import ActivityValue from './ActivityValue'
import { StatusClass } from 'types/shared'
import PlayerVisualizer from 'modules/shared/Visualizer/PlayerVisualizer'
import useAudioBlobURL from '../../ActivityInput/ActivityDocumentAudio/useAudioBlobURL'

interface ActivityDocumentVideoProps {
  values: string
  statusClass?: StatusClass
  hideDescription?: boolean
}

const ActivityDocumentAudio = ({
  values,
  statusClass,
  hideDescription
}: ActivityDocumentVideoProps) => {
  const { t } = useTranslation()

  const obj = values ? JSON.parse(values) : {}

  const audioBlobURL = useAudioBlobURL(obj?.url)

  return (
    <>
      {!hideDescription && (
        <ActivityValue
          label={t('activity-document-audio.labels.des')}
          value={obj.des}
          statusClass={statusClass}
        />
      )}
      <ActivityValue
        label={t('activity-document-audio.labels.uuid-audio')}
        value={obj.uuid}
        statusClass={statusClass}
      />
      <ActivityValue
        label={t('activity-document-audio.labels.status')}
        value={obj.statusDes}
        statusClass={statusClass}
      />
      <div className='row'>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-audio.labels.content-type')}
            value={obj.contentType}
            statusClass={statusClass}
          />
        </div>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-video.labels.size')}
            value={obj.size ? formatFileSize(Number(obj.size)) : ''}
            statusClass={statusClass}
          />
        </div>
      </div>
      <div className='w-100 d-flex justify-content-center align-items-center'>
        {audioBlobURL ? (
          <PlayerVisualizer url={audioBlobURL} variant='secondary' />
        ) : (
          <div className='w-100 webcam-no-image rounded'>
            {t('activity-document-audio.no-audio')}
          </div>
        )}
      </div>
    </>
  )
}

export default ActivityDocumentAudio
